var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLargeLogoPresentation = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 18,
    viewBox: "0 0 74 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.22706 16.5765H0V9.28158C0 4.61846 3.81689 0.82489 8.50867 0.82489C9.34592 0.82489 10.176 0.946056 10.9702 1.18483C11.4847 1.33985 11.9867 1.54476 12.4636 1.79244L10.9612 4.63093C10.6672 4.47769 10.3553 4.3494 10.0361 4.25496C9.54312 4.10707 9.02859 4.03223 8.50688 4.03223C5.59715 4.03223 3.22706 6.38606 3.22706 9.28158V16.5765Z",
    fill: "#BABABF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1429 0.83551C43.3878 0.83551 41.8047 1.58211 40.6968 2.77239C39.5906 1.58211 38.0075 0.83551 36.2524 0.83551C32.9106 0.83551 30.1927 3.5368 30.1927 6.85818V16.5764H33.4197V6.85818C33.4197 5.30619 34.6908 4.04285 36.2524 4.04285C37.8139 4.04285 39.085 5.30619 39.085 6.85818V16.5764H42.3121V6.85818C42.3121 5.30619 43.5832 4.04285 45.1447 4.04285C46.7062 4.04285 47.9773 5.30619 47.9773 6.85818V16.5764H51.2044V6.85818C51.2026 3.5368 48.4847 0.83551 45.1429 0.83551Z",
    fill: "#BABABF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7514 7.62262C70.2692 11.1489 67.2214 13.8752 63.5425 13.8752C59.8637 13.8752 56.8159 11.1489 56.3337 7.62262H53.0851C53.5835 12.9219 58.0834 17.0825 63.5425 17.0825C69.0017 17.0825 73.4998 12.9219 74 7.62262H70.7514V7.62262Z",
    fill: "#BABABF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5425 10.4344C66.1545 10.4344 68.272 8.3299 68.272 5.73386C68.272 3.13783 66.1545 1.03333 63.5425 1.03333C60.9305 1.03333 58.8131 3.13783 58.8131 5.73386C58.8131 8.3299 60.9305 10.4344 63.5425 10.4344Z",
    fill: "#BABABF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8165 10.1582H28.4842C28.538 9.78045 28.5649 9.39379 28.5649 9C28.5649 4.4135 24.8233 0.694763 20.2086 0.694763C15.5939 0.694763 11.8505 4.4135 11.8505 9C11.8505 13.5865 15.5921 17.3052 20.2068 17.3052C23.9735 17.3052 27.1575 14.8284 28.2009 11.4251H24.9685C24.0811 13.1428 22.2829 14.3188 20.205 14.3188C17.6485 14.3188 15.5132 12.5388 14.9808 10.1564H25.4275H25.8165V10.1582ZM20.2086 3.68115C22.6845 3.68115 24.7677 5.35254 25.3791 7.62262H15.0381C15.6495 5.35254 17.7327 3.68115 20.2086 3.68115Z",
    fill: "#BABABF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLargeLogoPresentation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/large-logo-presentation.70f558f0fa1cef6edc4218c64e17629e.svg";